export default "__VITE_ASSET__GJg_hIKv__"